import { render, staticRenderFns } from "./UserProfileDetailProvider.vue?vue&type=template&id=27e99d4c&scoped=true&"
import script from "./UserProfileDetailProvider.vue?vue&type=script&lang=js&"
export * from "./UserProfileDetailProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e99d4c",
  null
  
)

export default component.exports